// extracted by mini-css-extract-plugin
export default {"giftcard":"Cadeaubon_giftcard__NBSTN"};